import { Translations } from "../types";

export const en: Translations = {
  common: {
    upload: "Upload",
    remove: "Remove",
    replace: "Replace",
    choose: "Choose",
    file: "File",
    files: "Files",
    title: "Sticker Customizer",
  },

  preview: {
    title: "Image Preview",
    uploadTitle: "Upload Sticker Image",
    fileTypes: "PNG, JPG files",
    chooseFile: "Choose File",
  },

  sections: {
    shapeAndSize: "Shape & Size",
    material: "Material",
    model: "Model",
    stickerPreview: "Sticker Preview",
  },

  shapes: {
    rectangle: "RECT",
    circle: "CIRCLE",
    contour: "CONTOUR",
  },

  materials: {
    glossy: "Glossy",
    glossyDesc: "High shine finish",
    matte: "Matte",
    matteDesc: "Non-reflective finish",
    translucent: "Translucent",
    translucentDesc: "Semi-transparent",
  },

  models: {
    coffeeMug: "Coffee Mug",
    bassGuitar: "Bass Guitar",
    zippoLighter: "Zippo Lighter",
  },

  categories: {
    drinkware: "drinkware",
    instruments: "instruments",
    accessories: "accessories",
  },

  units: {
    mm: "mm",
    cm: "cm",
  },

  toolbar: {
    focusMode: "Focus Mode",
    focusModeDesc: "Click on model to focus and view details",
    stickerMode: "Sticker Mode",
    stickerModeDesc: "Click on model to apply sticker",
    textureMode: "Texture Mode",
    textureModeDesc: "Paint sticker onto model texture",
    decalMode: "Decal Mode",
    decalModeDesc: "Project sticker onto model surface",
    resetCamera: "Reset Camera",
    resetCameraDesc: "Return to default camera position",
  },

  canvasPreview: {
    desc: "Real-time display of sticker position on texture",
  },
};
